// Lightweight chess sound effects synthesized via Web Audio API.
// No audio files to bundle, no third-party CDN, no licensing concerns.
//
// Browsers block audio until the first user interaction, so the AudioContext
// is created lazily on first call. After that it works for the rest of the
// session.

let audioCtx = null;

function ctx() {
    if (audioCtx) return audioCtx;
    try {
        const Ctor = window.AudioContext || window.webkitAudioContext;
        if (!Ctor) return null;
        audioCtx = new Ctor();
    } catch {
        return null;
    }
    return audioCtx;
}

// Resume the context if a previous browser autoplay block left it suspended.
function resume() {
    const c = ctx();
    if (c && c.state === "suspended") {
        c.resume().catch(() => {});
    }
    return c;
}

// One short tone with a fast attack and exponential decay — sounds
// percussive enough to read as a board click.
function tone(freq, duration, gain = 0.18, type = "triangle", delay = 0) {
    const c = resume();
    if (!c) return;
    const t = c.currentTime + delay;
    const osc = c.createOscillator();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t);
    const g = c.createGain();
    g.gain.setValueAtTime(0, t);
    g.gain.linearRampToValueAtTime(gain, t + 0.005);
    g.gain.exponentialRampToValueAtTime(0.001, t + duration);
    osc.connect(g).connect(c.destination);
    osc.start(t);
    osc.stop(t + duration + 0.02);
}

export function playMove() {
    tone(260, 0.07, 0.18, "triangle");
}

export function playCapture() {
    // Two-layer thud: low fundamental plus a quick attack tone for "thunk".
    tone(160, 0.12, 0.22, "triangle");
    tone(110, 0.16, 0.16, "sine", 0.015);
}

export function playCheck() {
    // Two short alarm-style beeps.
    tone(680, 0.06, 0.14, "triangle");
    tone(680, 0.06, 0.14, "triangle", 0.10);
}

export function playGameEnd() {
    tone(440, 0.18, 0.16, "triangle");
    tone(330, 0.18, 0.16, "triangle", 0.16);
    tone(220, 0.30, 0.16, "triangle", 0.32);
}

export function playGameStart() {
    tone(330, 0.10, 0.14, "triangle");
    tone(440, 0.12, 0.14, "triangle", 0.08);
}
